import { render, staticRenderFns } from "./inventorydetails.vue?vue&type=template&id=c4e3360e&scoped=true&"
import script from "./inventorydetails.vue?vue&type=script&lang=js&"
export * from "./inventorydetails.vue?vue&type=script&lang=js&"
import style0 from "./inventorydetails.vue?vue&type=style&index=0&id=c4e3360e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e3360e",
  null
  
)

export default component.exports